import {Field, ErrorMessage, Formik, Form} from 'formik'
import * as Yup from 'yup'
import {FC, useContext} from 'react'
import {Booking, Review} from '../../../modules/apps/booking/list/core/_models'
import {useAuth} from '../../../modules/auth'
import {createReview} from '../../../modules/apps/booking/list/core/_requests'
import {RatingComponent} from '../../../../_component/Rating'
import {ListLoading} from '../../../../_component/ListLoading'
import {BookingContext} from '../../barber-shop/Page'
import {useQueryClient} from '@tanstack/react-query'
import {QUERIES} from '../../../../_metronic/helpers'

const bookingSchema = Yup.object().shape({
  review: Yup.string().label('Review'),
})
export const ReviewModalForm: FC<{booking: Booking}> = ({booking}) => {
  const queryClient = useQueryClient()
  const {currentUser} = useAuth()
  const {id, setReviewShow} = useContext(BookingContext)
  const submit = async (values: Review) => {
    try {
      await createReview(values)
      queryClient.invalidateQueries([`${QUERIES.BOOKINGS_LIST}-booking-${id}`])
      setReviewShow(false)
    } catch (ex) {
      console.error(ex)
    }
  }
  return (
    <Formik
      enableReinitialize={true}
      validationSchema={bookingSchema}
      initialValues={{booking_id: id, review: ''}}
      onSubmit={submit}
    >
      {(formik) => (
        <>
          <Form className='form' id='kt_modal_add_booking_form'>
            <div
              className='d-flex flex-column scroll-y me-n7 pe-7'
              id='kt_modal_add_booking_scroll'
              data-kt-scroll='true'
              data-kt-scroll-activate='{default: false, lg: true}'
              data-kt-scroll-max-height='auto'
              data-kt-scroll-dependencies='#kt_modal_add_booking_header'
              data-kt-scroll-wrappers='#kt_modal_add_booking_scroll'
              data-kt-scroll-offset='300px'
            ></div>
            <div className='row'>
              <div className='mb-5 fv-row'>
                <label className='form-label mb-3'>Review</label>

                <Field
                  type='text'
                  as='textarea'
                  className='form-control form-control-lg form-control-solid'
                  name='review'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='review' />
                </div>
              </div>
              {currentUser?.account_id === booking.created_by && (
                <div className='mb-5 fv-row'>
                  <label className='form-label mb-3'>Rate</label>
                  <RatingComponent
                    value={0}
                    setValue={(e) => formik.setFieldValue('rating', e)}
                    id={id}
                  />
                </div>
              )}
            </div>
            {/* <ReviewModalFormComponent formik={formik} defaultData={defaultData} /> */}
            <div className='text-center pt-15'>
              <button
                type='reset'
                onClick={() => setReviewShow(false)}
                className='btn btn-light mx-2'
                data-kt-bookings-modal-action='cancel'
                disabled={formik.isSubmitting}
              >
                Discard
              </button>
              <button
                className='btn btn-primary mx-2'
                disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                type='submit'
                data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}
                onClick={() => formik.setFieldValue('status', true)}
              >
                <span className='indicator-label'>Save</span>
                <span className='indicator-progress'>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              </button>
            </div>
          </Form>
          {formik.isSubmitting && <ListLoading />}
        </>
      )}
    </Formik>
  )
}
